import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick"
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { useTranslation } from "react-i18next";

import { cn } from "../../../../utils/classnames";
import { LazyImage } from "./LazyImage";

const NextArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="tw:absolute tw:bottom-8 tw:lg:bottom-14 tw:right-5 tw:lg:right-0 tw:z-10">
      <div
        className={cn(
          "tw:!bg-black tw:!rounded-full tw:w-[26px] tw:h-[26px] tw:lg:w-[30px] tw:lg:h-[30px] tw:flex tw:items-center tw:justify-center tw:cursor-pointer"
        )}
        onClick={onClick}
      >
        <FiArrowRight color="#ffffff" />
      </div>
    </div>
  );
}

const PrevArrow = (props) => {
  const { onClick } = props;
  return (
    <div className="tw:absolute tw:bottom-8 tw:lg:bottom-14 tw:right-[62px] tw:lg:right-[42px] tw:z-10">
      <div
        className={cn(
          "tw:!bg-black tw:!rounded-full tw:w-[26px] tw:h-[26px] tw:lg:w-[30px] tw:lg:h-[30px] tw:flex tw:items-center tw:justify-center tw:cursor-pointer"
        )}
        onClick={onClick}
      >
        <FiArrowLeft color="#ffffff" />
      </div>
    </div>
  );
}

export const CarImageSlide = ({ images }) => {
  const { i18n } = useTranslation();
  const settingsSlide = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };
  return (
    <Slider {...settingsSlide} className="tw:!static" key={Math.random()}>
      {images.map((image, index) => (
        <div className="tw:px-[5px]" key={image.src}>
          <div className="tw:cursor-pointer">
            <LazyImage
              src={image.src}
              alt="Toyota Alphard"
              className="tw:rounded-md tw:object-cover tw:w-full"
              loading="lazy"
              onClick={image.onClick}
            />
          </div>
          {image.caption && (
            <div className="tw:mt-3 tw:text-[#7C7B7B] tw:text-[13px] tw:font-normal tw:font-hanken-grotesk">
              {image.caption[i18n.language] || image.caption.en}
            </div>
          )}
        </div>
      ))}
    </Slider>
  )
}